import { assert } from '../app/logger.js';
import { PipeableArray } from '../base/pipeable/pipeable_array.js';
import { window } from '../window.js';

/**
 * Pipes an array data to UI.
 *
 * @param pipeable    the pipeable array
 * @param parentNode  parent DOM node to insert piped DOM elements into
 * @param uiFunc      the function returning markup for a given data item
 * @param elFunc      [optional] called for each inserted/changed DOM element
 * @param onCleared   [optional] called when the array has no items anymore
 * @param onStocked   [optional] called when a first item is inserted
 */
function pipeUI({
  pipeable,
  parentNode,
  uiFunc,
  elFunc,
  onCleared,
  onStocked,
}) {
  assert(pipeable instanceof PipeableArray, `[ui] not a pipeable array`);

  let pipe = pipeable.pipe({
    inserted({ is, idx }) {
      let template = window.document.createElement('template');
      template.innerHTML = uiFunc(is);
      let refEl = parentNode.children[idx];
      parentNode.insertBefore(template.content, refEl);
      if (elFunc) {
        elFunc(parentNode.children[idx], is);
      }
    },
    deleted({ idx }) {
      parentNode.children[idx].remove();
    },
    changed({ is, idx }) {
      parentNode.children[idx].outerHTML = uiFunc(is);
      if (elFunc) {
        elFunc(parentNode.children[idx], is);
      }
    },
    cleared() {
      onCleared?.();
    },
    stocked() {
      onStocked?.();
    },
  });

  return {
    unpipe() {
      parentNode.innerHTML = '';
      return pipe.unpipe();
    },
  };
}

export { pipeUI };
